module.exports = __webpack_public_path__ + "img/works_maum_btm_m.0926ba3b.jpg";